import React, { useState, useEffect } from "react";
import "./App.css";
import krLogo from "./assets/kr-logo.jpg";
import krPortrait from "./assets/kr-portrait.jpg";
import { SiteHeader } from "./components/SiteHeader";
import { Hero } from "./components/Hero";
import { CredentialsBar } from "./components/CredentialsBar";
import { AboutCredentials } from "./components/AboutCredentials";
import { SignatureServices } from "./components/SignatureServices";
import { ContactClinics } from "./components/ContactClinics";
import { SiteFooter } from "./components/SiteFooter";

function App() {
  const [activeSection, setActiveSection] = useState("home");
  const [consultForm, setConsultForm] = useState({
    name: "",
    email: "",
    phone: "",
    treatment: "",
    message: "",
  });
  const [consultStatus, setConsultStatus] = useState("");
  const [consultLoading, setConsultLoading] = useState(false);

  const handleConsultChange = (e) => {
    const { name, value } = e.target;
    setConsultForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleConsultSubmit = async (e) => {
    e.preventDefault();
    setConsultLoading(true);
    setConsultStatus("");
    try {
      const res = await fetch("https://consultation-rkkl4dicva-uc.a.run.app", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: consultForm.name,
          email: consultForm.email,
          message: `Phone: ${consultForm.phone}\nTreatment: ${consultForm.treatment}\nMessage: ${consultForm.message}`,
        }),
      });
      if (res.ok) {
        setConsultStatus("Your consultation request has been sent!");
        setConsultForm({
          name: "",
          email: "",
          phone: "",
          treatment: "",
          message: "",
        });
      } else {
        setConsultStatus(
          "Failed to send your request. Please try again later."
        );
      }
    } catch {
      setConsultStatus("Failed to send your request. Please try again later.");
    }
    setConsultLoading(false);
  };

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      setActiveSection(sectionId);
    }
  };

  useEffect(() => {
    const sections = ["home", "about", "services", "contact"];

    const handleScroll = () => {
      const headerOffset = 140;
      const y = window.scrollY;
      let current = sections[0];

      for (const id of sections) {
        const section = document.getElementById(id);
        if (section && y >= section.offsetTop - headerOffset) {
          current = id;
        }
      }
      setActiveSection(current);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <SiteHeader activeSection={activeSection} scrollToSection={scrollToSection} />
      <main>
        <Hero portraitSrc={krPortrait} scrollToSection={scrollToSection} />
        <CredentialsBar />
        <AboutCredentials />
        <SignatureServices scrollToSection={scrollToSection} />
        <ContactClinics
          consultForm={consultForm}
          handleConsultChange={handleConsultChange}
          handleConsultSubmit={handleConsultSubmit}
          consultStatus={consultStatus}
          consultLoading={consultLoading}
        />
      </main>
      <SiteFooter logoSrc={krLogo} />
    </div>
  );
}

export default App;
